export default "__VITE_ASSET__ErS3JnJd__"